<!--申报项目列表-->
<template>
   <div>
      <!--搜索栏-->
      <div class="contribute">
         <div class="inner_view">
            <div class="spanClass">
               <span style="line-height: 32px">申报单位:</span>
               <el-input v-model="filter.companyName" placeholder="请输入申报单位名称"
                         :clearable="true" style="margin-left: 10px;width: 200px;"></el-input>
            </div>
            <div class="spanClass">
               <span style="line-height: 32px">状态:</span>
               <el-select v-model="filter.status" clearable filterable
                          placeholder="请选择状态" style="margin-left: 10px;width: 200px;">
                  <el-option v-for="(item,i) in ddl.statusList" :key="i" :label="item.text"
                             :value="item.value">
                  </el-option>
               </el-select>
            </div>
            <div class="spanClass">
               <span style="line-height: 32px">申报时间:</span>
               <el-date-picker v-model="filter.applyDateStart" value-format="yyyy-MM-dd"
                               style="width: 135px;margin-left: 10px;">
               </el-date-picker>
               <span style="line-height: 32px">~</span>
               <el-date-picker v-model="filter.applyDateEnd" value-format="yyyy-MM-dd"
                               style="width: 135px;margin-right: 20px;">
               </el-date-picker>
            </div>
         </div>
         <div>
            <el-button type="primary" style="margin-left: 20px" @click="searchData">
               查询
            </el-button>
         </div>
      </div>
      <!--表格数据展示-->
      <div class="contribute tableContainer">
         <el-table :data="table.data" border ref="mainTable" row-key="rowID" v-loading="table.showLoading">
            <el-table-column type="index" :index="indexNo" label="序号" width="50" fixed="left"></el-table-column>
            <div v-for="(item,index) in table.column" :key="index">
               <el-table-column :prop="item.prop" :label="item.label"></el-table-column>
            </div>
            <el-table-column fixed="right" label="操作">
               <template v-slot="scope">
                  <el-button type="text" v-if="scope.row.status !=0" size="small" @click="rowDetail(scope.row)">
                     查看
                  </el-button>
                  <el-button type="text" v-if="scope.row.status ==1" size="small" @click="rowAudit(scope.row)">
                     审核
                  </el-button>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <!--分页栏-->
      <div style="margin-top: 50px;" v-if="pager.rowCount>10">
         <el-pagination background :layout="pager.layout" :current-page="pager.pageIndex" :page-size="pager.pageSize"
                        :total="pager.rowCount" @size-change="pageSizeChange"
                        @current-change="pageIndexChange"></el-pagination>
      </div>
      <!--要展示的对话框-->
      <div class="dialog">
         <audit-dialog ref="auditDialog" @dialogClose="this.searchData"></audit-dialog>
      </div>
   </div>
</template>

<script>
   import {getApplyList_Recom} from '@/api/modules/advCompanyApply.js'
   import auditDialog from "@/views/advCompanyRecom/components/auditDialog";

   export default {
      data() {
         return {
            filter: {
               companyName: '',
               status: '',
               applyDateStart: '',
               applyDateEnd: '',
            },
            pager: {
               layout: 'total, sizes, prev, pager, next, jumper',
               pageIndex: 1,
               pageSize: 10,
               rowCount: 0,
            },
            table: {
               data: [],
               //表格列配置
               column: [{'prop': 'project_name', 'label': '项目名称'},
                  {'prop': 'applyCompanyName', 'label': '申报单位'},
                  {'prop': 'createUserName', 'label': '申报人'},
                  {'prop': 'applyDate', 'label': '申报时间'},
                  {'prop': 'statusShow', 'label': '状态'},],
               showLoading: false
            },
            ddl: {
               //处理状态
               statusList: [
                  {'text': '待审核', 'value': '1'},
                  {'text': '待推荐', 'value': '2'},
                  {'text': '不同意', 'value': '7'},
                  {'text': '已退回', 'value': '8'},
                  {'text': '已推荐', 'value': '9'},]
            }
         }
      },
      components: {
         auditDialog
      },
      created() {
         this.searchData()
      },
      computed: {
         //计算行号
         indexNo() {
            return this.pager.pageSize * (this.pager.pageIndex - 1) + 1
         },
      },
      methods: {
         /*申请查看*/
         async rowDetail(row) {
            localStorage.setItem("opMode", "detail");
            this.$router.push({
               path: '/index/advCompanyRecom/apply',
               query: {prjApplyCode: row.project_application_id}
            });
         },
         /*申报审核*/
         async rowAudit(row) {
            this.$refs.auditDialog.showDialog(row.project_application_id);
         },
         //获取数据
         async searchData() {
            const params = {
               ...this.filter,
               //推荐单位编号 获取该推荐单位相关的项目
               recommend_unit: localStorage.getItem('company_code'),
               pageIndex: this.pager.pageIndex,
               pageSize: this.pager.pageSize
            }
            console.info(params);
            this.loading = true
            await getApplyList_Recom({
               data: params,
               success: (res) => {
                  this.table.data = res.data.list;
                  this.pager.rowCount = res.data.pageInfo.rowCount
                  this.loading = false
               }
            })
         },
         //换页切换
         pageIndexChange(val) {
            this.pager.pageIndex = val
            this.searchData()
         },
         //分页数量切换
         pageSizeChange(val) {
            this.pager.pageSize = val
            this.searchData()
         },
         //显示模态对话框
         showDialog(type, row) {
            this.$refs[type].showDialog(row);
         },
      }
   }
</script>

<style scoped="scoped">

   .tableContainer {
      width: 100%;
      min-height: 90px;
      height: auto;
      background-color: #f9f9f9;
   }

   .tableContainer thead th {
      background-color: #dce0e6 !important;
      font-weight: bold;
      font-size: 15px;
      width: calc(100% - 2px);
   }

   .contribute {
      display: flex;
      margin: 20px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-height: 40px;
   }

   .inner_view {
      line-height: 50px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      align-content: space-around;
      justify-content: flex-start;
   }

   .spanClass {
      line-height: 32px;
      margin-left: 20px;
   }

</style>
